import GridModel from './grid';
import Grid3DModel from './grid3d';
import HeatMapModel from './heatmap';
import HexagonModel from './hexagon';
var HeatMapModels = {
  heatmap: HeatMapModel,
  heatmap3d: HeatMapModel,
  grid: GridModel,
  grid3d: Grid3DModel,
  hexagon: HexagonModel
};
export default HeatMapModels;
//# sourceMappingURL=index.js.map